/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var VersionsStatusIcon = createIcon("VersionsStatusIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M5.188 4.719V1.906A.937.937 0 016.125.97h4.768c.249 0 .487.098.663.274l1.795 1.795a.937.937 0 01.274.663v6.643a.938.938 0 01-.938.937h-1.874",
    fill: "#0F71C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.188 4.719V1.906A.937.937 0 016.125.97h4.768c.249 0 .487.098.663.274l1.795 1.795a.937.937 0 01.274.663v6.643a.938.938 0 01-.938.937h-1.874",
    stroke: "#0F71C1",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.813 14.094a.938.938 0 01-.938.937H3.312a.937.937 0 01-.937-.937V5.656a.937.937 0 01.938-.937H8.08c.248 0 .486.098.662.274l1.795 1.795a.937.937 0 01.274.663v6.643Z",
    fill: "#2CA6FF",
    stroke: "#2CA6FF",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}, {});